
import { atom } from 'recoil';
import { Workspace, WorkspaceScore, WorkspaceUserMembership } from '../types/files';

const workspacesLoadedState = atom<boolean>({
  key: 'workspaces/workspacesLoaded',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspacesLoaded', newValue]);
    });
  }],
});

const workspacesState = atom<Workspace[]>({
  key: 'workspaces/workspaces',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaces', newValue]);
    });
  }],
});

const workspaceUserMembershipsState = atom<WorkspaceUserMembership[]>({
  key: 'workspaces/workspaceUserMemberships',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaceUserMemberships', newValue]);
    });
  }],
});

const workspaceScoresState = atom<WorkspaceScore[]>({
  key: 'workspaces/workspaceScores',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaceScores', newValue]);
    });
  }],
});

export {
  workspacesLoadedState,
  workspacesState,
  workspaceUserMembershipsState,
  workspaceScoresState
};
